var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",null,{"on":on,"attrs":attrs})]}},{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'v-dialog',_vm.mergedProps,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }